import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seo-agence',
  templateUrl: './seo-agence.component.html',
  styleUrls: ['./seo-agence.component.scss']
})
export class SeoAgenceComponent implements OnInit {

  currentYear = new Date().getFullYear();

  
  activeFaq: number | null = null;

  constructor() {}

  ngOnInit(): void {}

  scrollToSection(id: string): void {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  toggleFaq(index: number): void {
    this.activeFaq = this.activeFaq === index ? null : index;
  }
}
